import React, { useState, useEffect } from "react";
import { Player } from "../types";

interface PlayerFormProps {
  player?: Player;
  onSubmit: (player: Player) => void;
  onCancel: () => void;
}

const PlayerForm: React.FC<PlayerFormProps> = ({
  player,
  onSubmit,
  onCancel,
}) => {
  const [player_name, setName] = useState("");
  const [player_lok, setLok] = useState(0);
  const [player_elo, setElo] = useState(0);
  const [player_handicap, setHandicap] = useState(0);
  const [showAdvanced, setShowAdvanced] = useState(false);

  useEffect(() => {
    if (player) {
      setName(player.player_name);
      setLok(player.player_lok);
      setElo(player.player_elo);
      setHandicap(player.player_handicap);
    }
  }, [player]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      id: player?.id || "",
      player_name,
      player_lok,
      player_elo,
      player_handicap,
      player_created: Date.now(),
      player_updated: Date.now(),
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 p-6 bg-gray-100 rounded-md"
    >
      <div>
        <label htmlFor="name" className="block text-sm font-medium">
          Jméno
        </label>
        <input
          type="text"
          id="name"
          value={player_name}
          onChange={(e) => setName(e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
          required
        />
      </div>

      <div>
        <label htmlFor="handicap" className="block text-sm font-medium">
          Handicap
        </label>
        <input
          type="number"
          id="handicap"
          value={player_handicap}
          step="0.01"
          onChange={(e) => setHandicap(Number(e.target.value))}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
        />
      </div>

      <div>
        <button
          type="button"
          onClick={() => setShowAdvanced(!showAdvanced)}
          className="text-blue-500 hover:text-blue-700 text-sm"
        >
          {showAdvanced
            ? "Skrýt rozšířené možnosti"
            : "Zobrazit rozšířené možnosti"}
        </button>
      </div>

      {showAdvanced && (
        <div className="p-3 border border-gray-200 rounded-md bg-gray-50">
          <div className="mb-3">
            <label htmlFor="lok" className="block text-sm font-medium">
              LOK
            </label>
            <input
              type="number"
              id="lok"
              value={player_lok}
              onChange={(e) => setLok(Number(e.target.value))}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
            />
          </div>

          <div>
            <label htmlFor="elo" className="block text-sm font-medium">
              ELO
            </label>
            <input
              type="number"
              id="elo"
              value={player_elo}
              onChange={(e) => setElo(Number(e.target.value))}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
            />
          </div>
        </div>
      )}

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Zrušit
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700"
        >
          {player ? "Uložit změny" : "Přidat hráče"}
        </button>
      </div>
    </form>
  );
};

export default PlayerForm;
